import React, { useState, useEffect } from 'react';
import axios from 'axios';

import '../assets/css/AutoSchBox.css'
// 引入自訂參數
import { apiUrl } from '../config'

const AutoSchBox = (props) => {
    const [autofillWord, setAutofillWord] = useState(null)  
    const [prevSearchWord, setPrevSearchWord] = useState('')
    
    useEffect(() => {
        if(prevSearchWord !== props.searchWord){
            loadAutofillWord()
        }
    }, [props.searchWord])

    const recommandWord = () => {
        if (autofillWord) {
            return autofillWord.map((word, index) => (
                <div
                    className={"basicSearchAreaAutofillListOption"}
                    onClick={(e) => {
                        getKeyword(e, word.keyword)
                    }}
                    key={index}
                >
                    {word.keyword}
                </div>
            ))
        } else {
            return null
        }
    }
    
    const getKeyword = (e, keyword) => {
        setAutofillWord(null)
        setPrevSearchWord(keyword)
        console.log("getKeyword..."+keyword)
        props.setSearchWord(keyword)
    }

    const loadAutofillWord = async () => {
        try {
            const response = await axios.get(apiUrl + '/keyword', {
                params: {
                    keyword: props.searchWord
                }
            })
            setAutofillWord(response.data)
        } catch (error) {
            console.error(error)
        }
    }

    return (
        <div 
            id='autoSchBox'
            className={autofillWord && autofillWord[0] ? "basicSearchAreaAutofillList" : "basicSearchAreaAutofillList Hide"}
            style={{
                width: props.width,
                marginTop: '38px',
                marginLeft: '0px',
                borderTopLeftRadius: '4px',
                borderBottomLeftRadius: '4px',
                backgroundColor: '#b5d228'
            }}
        >
            {recommandWord()}
        </div>
    )
}
export default AutoSchBox;